// cancel order
import React, { Component, Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import { validatePassPhrase } from '../common/validators';

import { getAskOrder, getBidOrder, cancelAskOrder, cancelBidOrder} from '../common/ardorinterface';
import {SignActionField} from '../common/signactionfield';
import { fetchCard } from '../common/common';
import { CardInfo, CurrencyInfo } from '../common/cardinfo';
import { Typography } from '@material-ui/core';

import { NQTDIVIDER } from '../common/constants';
import { TxSuccess } from '../common/txsuccess';
import { ImgInventoryRow } from '../carddeck/thumb';
import Gem from './images/gems.svg';


const ColoredLine = ({ color }) => (
    <hr
        style={{
            color: color,
            backgroundColor: color,
            height: 1,
            width: '80%'
        }}
    />
  );
  



function OrderInfo({order}) {
    return(
        <Fragment>
            <Grid item>

                <Typography variant="body2" gutterBottom>Quantity • {order.quantityQNT}</Typography>
                <Typography variant="body2" gutterBottom>Price • {order.priceNQTPerShare/NQTDIVIDER}</Typography>
                <Typography variant="body2" gutterBottom>Type • {order.type}</Typography>
                <Typography variant="body2" gutterBottom>Blockheight • {order.height}</Typography>

            </Grid>
        </Fragment>
    );
}


function OrderInfoCurrency({order}) {
    return(
        <Fragment>
            <Grid item>
                 <Typography variant="body2" gutterBottom>Type • {order.type}</Typography>
                 <Typography variant="body2" gutterBottom>Blockheight • {order.height}</Typography>
                 <Typography variant="body2" gutterBottom>&nbsp;</Typography>
                <Typography variant="body2" gutterBottom>Amount • {order.quantityQNT/NQTDIVIDER} GEM</Typography>
                <Typography variant="body2" gutterBottom>Rate • {order.priceNQTPerShare/NQTDIVIDER} IGNIS</Typography>
                <Typography variant="body2" gutterBottom>Total Price • {(order.priceNQTPerShare/NQTDIVIDER)*order.quantityQNT/NQTDIVIDER} IGNIS</Typography>


            </Grid>
        </Fragment>
    );
}



export class CancelAskOrder extends Component{
    constructor(props){
        super(props);
        this.state={
            order:{},
            card:{},
            passPhrase:"",
            passPhraseStatus:"",
            bought:false
        }
        this.handlePassphraseChange = this.handlePassphraseChange.bind(this);
        this.cancelOrder = this.cancelOrder.bind(this);
    }

    componentDidMount(){
        var self = this;
        getAskOrder(self.props.nodeurl,self.props.match.params.order)
        .then(function(response) {
            //console.log(response);
            self.setState({order:response});
            fetchCard(self.props.nodeurl,self.props.user.accountRs,response.asset)
            .then((response) => {
                //console.log(response);
                self.setState({card:response});
            })
        })
    }

    cancelOrder(){
        var self = this;
        cancelAskOrder(this.props.nodeurl,2,this.state.order.order,this.state.passPhrase)
        .then(function(response){
            self.setState({response:response,responseTime:response.data.requestProcessingTime,bought:true,status:"success"});
          })
          .catch(function(error) {
            console.log("error caught!");
            console.log(error);
          });
    }
    
    handlePassphraseChange(value){
    this.setState(
        {passPhrase:value},
        ()=>{let fieldStatus = validatePassPhrase(value,this.state.passPhraseStatus);
            this.setState({passPhraseStatus:fieldStatus, formValid:!fieldStatus.invalid});}
        );
    }

    render(){
        //console.log(this.state);
        //console.log(this.props);
        
        if (this.state.bought){
            return(<TxSuccess/>)
        }
        else {
            return (           
                <div style={{textAlign:"center", padding:20, display:"inline-block"}}>               
                    <form onSubmit={(event)=>{event.preventDefault();this.cancelOrder()}}>
                        <Grid container
                            justify="center"
                            alignItems="stretch" 
                            direction="column"
                            spacing={24}             
                            style={{maxWidth:"500px",width:"500px", backgroundColor: '#1D1D1D', marginTop: 5, border:'1px solid', borderColor:'#ffffff10',boxShadow: "5px 5px 8px rgba(5, 5, 5, 0.32)"}}
                            className="boxed"
                        >
                        <Grid item >
                            <ImgInventoryRow card={this.state.card} />   
                            <Typography>&nbsp;</Typography>
                            <CardInfo card={this.state.card} />
                        </Grid>
                        <Grid item style={{textAlign:"center"}}>
                        <ColoredLine color="white"/>
                        <Typography variant="display1">Order details</Typography>
                        <Typography>&nbsp;</Typography>
                            <OrderInfo order={this.state.order}/>
                         <ColoredLine color="white"/>
                        </Grid>
                
                        <Grid item>
                        <Typography variant="display1">Cancel order</Typography>
                            <SignActionField  {...this.props} 
                                        handlePassphraseChange={this.handlePassphraseChange} 
                                        action={this.cancelOrder}
                                    />
                            </Grid>
                        </Grid>
                    </form>
                </div>
            )
        }
    }
}


export class CancelBidOrder extends Component{
    constructor(props){
        super(props);
        this.state={
            order:{},
            card:{},
            passPhrase:"",
            passPhraseStatus:"",
            bought:false
        }
        this.handlePassphraseChange = this.handlePassphraseChange.bind(this);
        this.cancelOrder = this.cancelOrder.bind(this);
    }

    componentDidMount(){
        var self = this;
        getBidOrder(self.props.nodeurl,self.props.match.params.order)
        .then(function(response) {
            //console.log(response);
            self.setState({order:response});
            fetchCard(self.props.nodeurl,self.props.user.accountRs,response.asset)
            .then((response) => {
                //console.log(response);
                self.setState({card:response});
            })
        })
    }

    cancelOrder(){
        var self = this;
        cancelBidOrder(this.props.nodeurl,2,this.state.order.order,this.state.passPhrase)
        .then(function(response){
            self.setState({response:response,responseTime:response.data.requestProcessingTime,bought:true,status:"success"});
          })
          .catch(function(error) {
            console.log("error caught!");
            console.log(error);
          });
    }
    
    handlePassphraseChange(value){
    this.setState(
        {passPhrase:value},
        ()=>{let fieldStatus = validatePassPhrase(value,this.state.passPhraseStatus);
            this.setState({passPhraseStatus:fieldStatus, formValid:!fieldStatus.invalid});}
        );
    }

    render(){
        //console.log(this.state);
        //console.log(this.props);
        
        if (this.state.bought){
            return(<TxSuccess/>)
        }
        else {
            return (
                <div style={{textAlign:"center", padding:20, display:"inline-block"}}>
                    <form onSubmit={(event)=>{event.preventDefault();this.cancelOrder()}}>
                    <Grid container
                            justify="center"
                            alignItems="stretch" 
                            direction="column"
                            spacing={24}             
                            style={{maxWidth:"500px",width:"500px", backgroundColor: '#1D1D1D', marginTop: 5, border:'1px solid', borderColor:'#ffffff10',boxShadow: "5px 5px 8px rgba(5, 5, 5, 0.32)"}}
                            className="boxed"
                        >
                        <Grid item >
                            <ImgInventoryRow card={this.state.card} />   
                            <Typography>&nbsp;</Typography>
                            <CardInfo card={this.state.card} />
                        </Grid>
                        <Grid item style={{textAlign:"center"}}>
                        <ColoredLine color="white"/>
                        <Typography variant="display1">Order details</Typography>
                        <Typography>&nbsp;</Typography>
                            <OrderInfo order={this.state.order}/>
                         <ColoredLine color="white"/>
                        </Grid>
                
                        <Grid item>
                        <Typography variant="display1">Cancel order</Typography>
                            <SignActionField  {...this.props} 
                                        handlePassphraseChange={this.handlePassphraseChange} 
                                        action={this.cancelOrder}
                                    />
                            </Grid>
                        </Grid>
                    </form>
                </div>
            )
            }
    }
}



export class CancelBidOrderCurrency extends Component{
    constructor(props){
        super(props);
        this.state={
            order:{},
            card:{},
            passPhrase:"",
            passPhraseStatus:"",
            bought:false
        }
        this.handlePassphraseChange = this.handlePassphraseChange.bind(this);
        this.cancelOrder = this.cancelOrder.bind(this);
    }

    componentDidMount(){
        var self = this;
        getBidOrder(self.props.nodeurl,self.props.match.params.order)
        .then(function(response) {
            //console.log(response);
            self.setState({order:response});
            fetchCard(self.props.nodeurl,self.props.user.accountRs,response.asset)
            .then((response) => {
                //console.log(response);
                self.setState({card:response});
            })
        })
    }

    cancelOrder(){
        var self = this;
        cancelBidOrder(this.props.nodeurl,2,this.state.order.order,this.state.passPhrase)
        .then(function(response){
            self.setState({response:response,responseTime:response.data.requestProcessingTime,bought:true,status:"success"});
          })
          .catch(function(error) {
            console.log("error caught!");
            console.log(error);
          });
    }
    
    handlePassphraseChange(value){
    this.setState(
        {passPhrase:value},
        ()=>{let fieldStatus = validatePassPhrase(value,this.state.passPhraseStatus);
            this.setState({passPhraseStatus:fieldStatus, formValid:!fieldStatus.invalid});}
        );
    }

    render(){
        //console.log(this.state);
        //console.log(this.props);
        
        if (this.state.bought){
            return(<TxSuccess/>)
        }
        else {
            return (
                <div style={{textAlign:"center", padding:20, display:"inline-block"}}>
                    <form onSubmit={(event)=>{event.preventDefault();this.cancelOrder()}}>
                    
                        <Grid container
                            justify="center"
                            alignItems="stretch" 
                            direction="column"
                            spacing={24}             
                            style={{maxWidth:"500px",width:"500px", backgroundColor: '#1D1D1D', marginTop: 5, marginBottom: 10, border:'1px solid', borderColor:'#ffffff10',boxShadow: "5px 5px 8px rgba(5, 5, 5, 0.32)"}}
                            className="boxed"
                        >
                          
                        <Grid item>
                            <img src={Gem} alt="Gem" width="50px" />
                            <Typography>&nbsp;</Typography>
                            <CurrencyInfo card={this.state.card}/>
                  
               
                      
                        <ColoredLine color="white"/>
                        <Typography variant="display1">Order details</Typography>
                        <Typography>&nbsp;</Typography>
                            <OrderInfoCurrency order={this.state.order}/>
                            <ColoredLine color="white"/>
                        </Grid>

                        <Grid item style={{textAlign:"center"}}>
                        <Typography variant="button">Cancel BID:</Typography>
                            <SignActionField  {...this.props} 
                                        handlePassphraseChange={this.handlePassphraseChange} 
                                        action={this.cancelOrder}
                                    />
                            </Grid>
                        </Grid>
                        
                    </form>
                </div>
            )
            }
    }
}

export class CancelAskOrderCurrency extends Component{
    constructor(props){
        super(props);
        this.state={
            order:{},
            card:{},
            passPhrase:"",
            passPhraseStatus:"",
            bought:false
        }
        this.handlePassphraseChange = this.handlePassphraseChange.bind(this);
        this.cancelOrder = this.cancelOrder.bind(this);
    }

    componentDidMount(){
        var self = this;
        getAskOrder(self.props.nodeurl,self.props.match.params.order)
        .then(function(response) {
            //console.log(response);
            self.setState({order:response});
            fetchCard(self.props.nodeurl,self.props.user.accountRs,response.asset)
            .then((response) => {
                //console.log(response);
                self.setState({card:response});
            })
        })
    }

    cancelOrder(){
        var self = this;
        cancelAskOrder(this.props.nodeurl,2,this.state.order.order,this.state.passPhrase)
        .then(function(response){
            self.setState({response:response,responseTime:response.data.requestProcessingTime,bought:true,status:"success"});
          })
          .catch(function(error) {
            console.log("error caught!");
            console.log(error);
          });
    }
    
    handlePassphraseChange(value){
    this.setState(
        {passPhrase:value},
        ()=>{let fieldStatus = validatePassPhrase(value,this.state.passPhraseStatus);
            this.setState({passPhraseStatus:fieldStatus, formValid:!fieldStatus.invalid});}
        );
    }

    render(){
        //console.log(this.state);
        //console.log(this.props);
        
        if (this.state.bought){
            return(<TxSuccess/>)
        }
        else {
            return (           
                <div style={{textAlign:"center", padding:20, display:"inline-block"}}>               
                    <form onSubmit={(event)=>{event.preventDefault();this.cancelOrder()}}>
                        <Grid container
                            justify="center"
                            alignItems="stretch" 
                            direction="column"
                            spacing={24}             
                            style={{maxWidth:"500px",width:"500px", backgroundColor: '#1D1D1D', marginTop: 5, marginBottom: 10, border:'1px solid', borderColor:'#ffffff10',boxShadow: "5px 5px 8px rgba(5, 5, 5, 0.32)"}}
                            className="boxed"
                        >
                        <Grid item >
                            <img src={Gem} alt="Gem" width="50px" />  
                            <Typography>&nbsp;</Typography>
                            <CurrencyInfo card={this.state.card} />
                     
                        <ColoredLine color="white"/>
                        <Typography variant="display1">Order details</Typography>
                        <Typography>&nbsp;</Typography>
                            <OrderInfoCurrency order={this.state.order}/>
                         <ColoredLine color="white"/>
                        </Grid>
                
                        <Grid item>
                        <Typography variant="button">Cancel ASK:</Typography>
                            <SignActionField  {...this.props} 
                                        handlePassphraseChange={this.handlePassphraseChange} 
                                        action={this.cancelOrder}
                                    />
                            </Grid>
                        </Grid>
                    </form>
                </div>
            )
        }
    }
}